import axios from 'axios'
import {Toast} from '../components/antd/Antd'
import {getAuthorizationHeader, getUserInfo} from './bridge'
import * as Sentry from '@sentry/browser'
import {logRed} from "./log"

let baseURL = process.env.REACT_APP_TEST === 'true'
  ? 'http://core.staging2.p1staff.com'
  : window.location.origin.includes('staging2')
    ? 'http://core.staging2.p1staff.com'
    : 'https://core.tantanapp.com'
const instance = axios.create({
  baseURL,
  timeout: 5000,
})
instance.interceptors.request.use(async (config) => {
  if (!config.headers.Authorization && config.url) {
    const auth = await getAuthorizationHeader(config.url, config.data)
    const {token} = await getUserInfo()
    config.baseURL = window['mytantanH5-gloable-inAB'] ? config.baseURL : ''
    return {
      ...config,
      params: {
        ...config.params,
      },
      headers: {
        ...config.headers,
        Authorization: auth,
        'H5-Authorization': token
      },
    }
  }
  return config
}, (error) => {
  Toast.info('系统异常', 0.5)
  // 拦截器异常错误.
  return null
})

instance.interceptors.response.use(function (response) {
  if (response.status === 200) {
    if (response.data && response.data.meta && response.data.meta.code === 200) {
      return Object.assign(response.data.data, {origin: response.data})
    }
    Sentry.withScope((scope) => {
      scope.setExtra('responseData', response)
      Sentry.captureException(new Error('status is 200, but code not'))
    })
    return null
  }
  Sentry.withScope((scope) => {
    scope.setExtra('responseData', response)
    Sentry.captureException(new Error('ajax error'))
  })
  return null
}, function (error) {
  Sentry.withScope((scope: any) => {
    scope.setExtra('errorInfo', error)
    Sentry.captureException(error)
  })
  return null
})

export const ajax = instance
